package com.esoris.kmpmoout.core.extension

fun String.toTitleCase(): String {

    return split(" ")
        .joinToString(" ") { word ->

            word.lowercase()
                .replaceFirstChar { char ->

                    if (char.isLowerCase()) {
                        char.titlecase()
                    } else {
                        char.toString()
                    }
                }
        }
}